import { useMemo } from "react";

import { Autocomplete, TextField } from "@mui/material";

import { getStandardMonthOptions } from "./helpers";

export interface MonthOption {
  label: string;
  value: string;
  lastDay: number;
}

const MonthsAutocomplete = ({
  extraOptions = [],
  onChange,
  value,
}: {
  extraOptions?: MonthOption[];
  onChange: (value: MonthOption) => void;
  value: MonthOption | null;
}) => {
  const monthOptions = useMemo<MonthOption[]>(() => {
    const options = getStandardMonthOptions();

    const existingValues = new Set(options.map((o) => o.value));
    const merged = [...extraOptions.filter((o) => !existingValues.has(o.value)), ...options];

    return merged;
  }, [extraOptions]);

  return (
    <Autocomplete
      disabled={!monthOptions.length}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, val) => option.value === val?.value}
      onChange={(_event, newValue) => onChange(newValue)}
      options={monthOptions}
      renderInput={(params) =>
        monthOptions.length ? (
          <TextField {...params} label="Report Month" />
        ) : (
          <TextField
            {...params}
            label="Report Month"
            placeholder="No Reports Available"
            slotProps={{ inputLabel: { ...params.InputLabelProps, shrink: true } }}
          />
        )
      }
      size="small"
      sx={{
        flexGrow: 1,
      }}
      // value is only null when there are no months available yet, so the user can never clear it
      value={value as MonthOption}
      disableClearable
    />
  );
};

export default MonthsAutocomplete;
